import {
    Box,
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
    MenuItemOption,
    MenuGroup,
    MenuOptionGroup,
    MenuDivider,
    Button,
    Text,
    Tooltip,
    VStack,
    Image
} from '@chakra-ui/react';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { Icon } from '@blueprintjs/core';
import UIContext from '../../context/UIContext';
import { useHistory, useLocation } from 'react-router-dom';

function truncate(n) {
    return n > 0 ? Math.floor(n) : Math.ceil(n);
}

function getDMS(dd, longOrLat) {
    if (!dd) {
        return '--';
    }
    let hemisphere = /^[WE]|(?:lon)/i.test(longOrLat)
    ? dd < 0
      ? "W"
      : "E"
    : dd < 0
      ? "S"
      : "N";

    const absDD = Math.abs(dd);
    const degrees = truncate(absDD);
    const minutes = truncate((absDD - degrees) * 60);
    const seconds = ((absDD - degrees - minutes / 60) * Math.pow(60, 2)).toFixed(2);

    let dmsArray = [degrees, minutes, seconds, hemisphere];
    return `${dmsArray[0]}°${dmsArray[1]}'${dmsArray[2]}" ${dmsArray[3]}`;
}

function formatElapsedTime(startTimestamp) {
    const now = Date.now();
    let elapsedMilliseconds = now - startTimestamp;

    if (elapsedMilliseconds < 0) {
        return "00:00:00"; // In case the timestamp is in the future
    }

    const seconds = Math.floor((elapsedMilliseconds / 1000) % 60);
    const minutes = Math.floor((elapsedMilliseconds / (1000 * 60)) % 60);
    const hours = Math.floor(elapsedMilliseconds / (1000 * 60 * 60));

    const pad = (num) => String(num).padStart(2, "0");

    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
}

// Example usage:
const startTime = Date.now() - 3661000; // 1 hour, 1 minute, and 1 second ago
console.log(formatElapsedTime(startTime)); // Output: "01:01:01"

function MobileToolbar() {
    const {
        mobileToolbarOpen,
        setMobileToolbarOpen,
        locationTracking,
        setLocationTracking,
        track,
        insets
    } = useContext(UIContext);

    let realHdg = track?.latest?.heading || null;
    if (realHdg < 0 || realHdg > 360) {
        realHdg = null;
    }

    return (
        <Box
            position="absolute"
            zIndex={2}
            bottom="0px"
            left="0px"
            right="0px"
            height={mobileToolbarOpen ? "300px" : "64px"}
            transition={"height 0.15s"}
            background="rgba(255,255,255,0.8)"
            boxShadow={'0px 0px 0px 2px rgba(0,0,0,0.1)'}
            display="flex"
            justifyContent="stretch"
            alignItems="stretch"
            flexDir="column"
        >
            <Box 
                h="40px"
                borderBottom="1px solid rgba(0,0,0,0.1)"
                flex="0 0 auto"
                overflow="hidden"
                display="flex"
                justifyContent="stretch"
                alignItems="center"
                flexDir="row"
                padding="0px"
                paddingLeft="10px"
                paddingRight="10px"
                bg="rgba(255,255,255,0.5)"
                onClick={() => setMobileToolbarOpen(!mobileToolbarOpen)}
            >
                <Text mb="0px" opacity={locationTracking ? "0.5" : "0.2"}
                color={locationTracking && "blue.500"}
                mr="5px" mt="-1px"><Icon icon="geolocation"></Icon></Text>
                <Text mb="0px" fontWeight={locationTracking ? "600" : "500"} color={locationTracking && "blue.500"}>{locationTracking ? "Tracking" : "Not Tracking"}</Text>
                <Box flex="1"></Box>
                {track && (
                    <Text fontWeight="500" color="blue.500">{formatElapsedTime(track.startTime)}</Text>
                )}
                <Button
                    _hover={{
                        bg: ''
                    }}
                    bg={''}
                    w="40px"
                    h={'40px'}
                    onClick={() => {
                        setMobileToolbarOpen(!mobileToolbarOpen)
                    }}
                    color={'rgba(0,0,0,0.8)'}
                    borderBottom="1px solid rgba(0,0,0,0.1)"
                >
                    <Text mb="0px">
                        <Icon icon={mobileToolbarOpen ? 'chevron-down' : 'chevron-up'} size="16" />
                    </Text>
                </Button>
            </Box>
        {mobileToolbarOpen && (
            <Box padding="5px"
                display="flex"
                justifyContent="stretch"
                alignItems="stretch"
                flexDir="column"
                columnGap="10px"
                rowGap="5px"
                flex="1"
                marginBottom={insets.bottom}
                paddingBottom="10px"
            >
                <Box
                display="flex"
                justifyContent="stretch"
                alignItems="stretch"
                flexDir="row"
                columnGap="5px"
                flex="1"
                >
                <Box flex="1" bg="rgba(255,255,255,0.5)" p="10px" borderRadius="5px" border="1px solid rgba(0,0,0,0.05)">
                    <Text fontSize="12px" fontWeight="500" opacity="0.8">POSITION</Text>
                    {track?.latest?.position ? (
                        <Text fontSize="22px" fontWeight="500">{getDMS(track?.latest?.position[1], 'lat')}, {getDMS(track?.latest?.position[0], 'long')}</Text>
                    ) : (
                        <Text fontSize="22px" fontWeight="500">None</Text>
                    )}
                </Box>
                <Box flex="0 0 auto" bg="rgba(255,255,255,0.5)" p="10px" borderRadius="5px" border="1px solid rgba(0,0,0,0.05)">
                    <Text fontSize="12px" fontWeight="500" opacity="0.8">COURSE</Text>
                    <Box
                        mt="5px"
                        flex="0 0 auto" 
                        position="relative"
                        w="100px"
                        height="100px"
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        flexDir="column"
                    >
                    <Text>{realHdg || '--'}</Text>
                    <Image
                        transform={`rotateZ(${realHdg}deg)`}
                        position="absolute"
                        top="0px"
                        bottom="0px"
                        left="0px"
                        right="0px"
                    src="/img/compass-360.svg"></Image>
                    </Box>
                </Box>
                </Box>
                <Button
                    _hover={{
                        bg: ''
                    }}
                    borderRadius="3px"
                    h="50px"
                    bg={locationTracking ? 'red.500' : 'blue.500'}
                    color="white"
                    onClick={() => setLocationTracking(!locationTracking)}
                >{locationTracking ? 'Stop' : 'Start'} Tracking</Button>
                <Box flex="1"></Box>
            </Box>
        )}
    </Box>
    )
}

export default MobileToolbar;